import { render, staticRenderFns } from "./HealthCheck25PsaThyroidLiverNR.vue?vue&type=template&id=44733900&scoped=true&"
import script from "./HealthCheck25PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck25PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck25PsaThyroidLiverNR.vue?vue&type=style&index=0&id=44733900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44733900",
  null
  
)

export default component.exports